import React from 'react';
import PropTypes from 'prop-types';
import { useDebugState } from 'Context/DebugContext';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { getBorder, getBorderRadius } from 'Components/utils';
import DevResourceViewer from '../DevResourceViewer';

const useStyles = buildUseStyles('', ((theme) => ({
  root: {
    margin: theme.spacing(1),
    padding: theme.spacing(2),
    gap: `${theme.spacing(2)}px`,
    ...getBorder(theme, { all: true }),
    ...getBorderRadius(theme.radius.md, { all: true }),
  },
})));

const DevCollectionViewer = ({
  collection,
  onRelationshipClick,
}) => {
  const { showDevElements } = useDebugState();
  const classes = useStyles();

  if (!showDevElements || !collection) {
    return null;
  }

  return (
    <Box
      className={classes.root}
      display={'flex'}
      flexDirection={'column'}
      alignItems={'flexStart'}
    >
      <Text
        value={'Collection'}
        color={'black'}
        variant={'h5'}
        weight={'bold'}
      />
      {collection.resources().list().map((v) => {
        return (
          <DevResourceViewer resource={v} onRelationshipClick={onRelationshipClick} />
        );
      })}
    </Box>
  );
};

DevCollectionViewer.propTypes = {
  collection: PropTypes.object.isRequired,
  onRelationshipClick: PropTypes.func.isRequired,
};

export default DevCollectionViewer;
